<div class="rollback-migration container-fluid">
    <!-- Page Header -->
    <app-page-header header="{{pageTitle}}" description="{{pageSubTitle}}">
    </app-page-header>
    <!-- Select Environment -->
    <div class="select-env row">
        <mat-form-field class="col-4">
            <mat-label>Select Environment <span class="required-filed-asterisk">*</span></mat-label>
            <mat-select (selectionChange)="onEnvironmentChange($event.value)"
                [(ngModel)]="selectedEnvironmentId">
                <mat-option>
                    <ngx-mat-select-search ngDefaultControl [formControl]="searchFilterControlEnvironments"
                        placeholderLabel="Search for environment..." noEntriesFoundLabel="'Not found'">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let env of filteredEnvironments" [value]="env.id">
                    {{env.environmentName}}
                </mat-option>
            </mat-select>
            <mat-icon matSuffix matTooltip="{{ configEnvInfoMsg }}" matTooltipPosition="right"
            class="env-info-icon"
                            aria-hidden="true" matTooltipClass="ey-custom-tooltip">info</mat-icon>
        </mat-form-field>
    </div>
    <div *ngIf="selectedEnvironmentId!==''">
        <ag-grid-angular #agGridRollBackMigration [style]="styleChipDiv" class="ag-theme-material" (gridReady)="onGridReady($event)"
            [columnDefs]="columnDefs" id="gridRollback" [headerHeight]="29"
            [defaultColDef]="defaultColDef"  [cacheBlockSize]="cacheBlockSize" [maxBlocksInCache]="maxBlocksInCache"
            [rowModelType]="rowModelType"
            [infiniteInitialRowCount]="infiniteInitialRowCount"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate" [gridOptions]="gridOptions" >
        </ag-grid-angular>            
    </div>


    <!-- Data rollback migration details slider start -->
    <div id="rollbackMigrationDetailsSlider" *ngIf="showRollbackMigrationDetailsSlider">
        <!-- slider -->
        <app-slider (closeSliderFunc)="closerollbackMigrationDetails()" [sliderId]="'rollbackMigrationDetailsSliderId'"
            [sliderHeader]="sliderDescription">
            <!-- slider content -->
            <app-rollback-migration-details [releaseLegoRollbackStatusId]="selectedReleaseLegoRollbackStatusId"> </app-rollback-migration-details>
        </app-slider>
        <!-- slider -->
    </div>
</div>